export default __webpack_public_path__ + "static/media/edit.58566fba.svg";